import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Card, CardBody, Row, FormGroup, Form, Input, ModalHeader, ModalBody } from 'reactstrap';
import { Preloading } from '../../../components/UI/Preloader/action.js';
import DropdownSelect from '../../../components/Dropdown';
import Table from "../../../components/UI/Table/Table.js";
import Modal from "../../../components/UI/Modal/Modal";
import * as constant from '../../../Analyst/Cases/List/constants';
import * as CounterpartySearchActions from './action';
import "./style.css";

import EditCounterpartyForm from './EditCounterpartyForm/index'
import { loadInitialCounterpartyData } from './EditCounterpartyForm/action';
import { loadInitialCounterpartyMasterData } from './EditCounterpartyMasterDataForm/action';
import EditCounterpartyMasterDataForm from './EditCounterpartyMasterDataForm/index'
import { createRequestBody } from './helper'
import { toast } from 'react-toastify';
const renderField = ({ input, label, type, isRequired, val, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)
class CounterpartySearch extends Component {
    
    constructor(props) {
        super(props);
        this.SEARCH_TYPES = ["Name", "GST", "CIN", "PAN"];
        this.state = {
            isOpen: false,
            searchResults: [],
            searchError: [],
            searchText: "",
            selectedSearchType: this.SEARCH_TYPES[0],
            showModal:false,
            selectedCounterparty: null,
            counterpartyMasterData: [],
            counterpartyMasterColumns: [],
            counterpartyData: [],
            counterpartyEditModal: false,
            counterpartyMasterDataEditModal: false,
            resizeZIndex: false
        }
    }

    componentDidMount() { 
        //console.log('search = ',this.props.location);
        const urlFilters = this.processUrlFilter(this.props.location.search);
    }

    componentDidUpdate(prevProps) {
        const { searchResults, searchError, counterpartyUpdateSuccess, counterpartyUpdateFailure, counterpartyMasterUpdateSuccess, counterpartyMasterUpdateFailure } = this.props;
        if (searchResults !== prevProps.searchResults) {
            //console.log('search success >',searchResults.data);
            this.props.preloading(false);
            this.setState({
                searchResults: searchResults.data,
                searchError: null
            });
        }
        else if (searchError !== prevProps.searchError) {
            // Handle search errors
            //console.log('ERROR >>', JSON.stringify(searchError));
            this.props.preloading(false);
            this.setState({
                searchResults: [],
                searchError: searchError
            });
        }
        if (counterpartyUpdateSuccess !== prevProps.counterpartyUpdateSuccess){
            this.props.preloading(false);
            this.setState({resizeZIndex : false})
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Counterparty Updated Successfully
                </div>
            );
        }
        else if (counterpartyUpdateFailure !== prevProps.counterpartyUpdateFailure){
            this.props.preloading(false);
            this.setState({resizeZIndex : false})
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Error in Updating Counterparty!!! {counterpartyUpdateFailure.error.response.data.message}
                </div>
            );
        }
        if (counterpartyMasterUpdateSuccess !== prevProps.counterpartyMasterUpdateSuccess) {
            this.props.preloading(false);
            this.setState({ resizeZIndex: false })
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Counterparty Master Data Updated Successfully
                </div>
            );
        }
        else if (counterpartyMasterUpdateFailure !== prevProps.counterpartyMasterUpdateFailure) {
            this.props.preloading(false);
            this.setState({ resizeZIndex: false })
            toast.error(
                <div>
                    <i className="fa fa-check"></i>&nbsp;Error in Updating Counterparty Master Data!!! {counterpartyMasterUpdateFailure.error.response.data.message}
                </div>
            );
        }
    }

    componentWillUnmount() { }

    dropdownCallback = (data) => {
        this.setState({
            selectedSearchType: data
        })
    }

    handleSearchChange = (event) => {
        if (event.key === constant.ENTER) {
            event.preventDefault()
            
            let searchSelector = this.state.selectedSearchType;
            let searchQuery = event.target.value;

            this.setUrlFilter(searchSelector, searchQuery);
            this.doSearch(searchSelector, searchQuery);
        }
    }

    doSearch = (searchSelector, searchQuery) => {
        this.props.preloading(true)

        this.setState({
            searchResults: [],
            searchError: [],
            searchText: searchQuery
        });
        this.props.search(searchSelector, searchQuery);

    }

    setUrlFilter = (searchSelector, searchQuery) => {
        let url = new URLSearchParams();
        url.set(searchSelector, searchQuery);
        
        const decodedUrl = decodeURIComponent(url);
        this.props.history.push(`?${decodedUrl}`);
    }

    processUrlFilter = (urlFilters) => {
        if(urlFilters){
            const params = new URLSearchParams(urlFilters);
            for (const [key, value] of params) {
                //console.log('url params=',key, value);
                this.setUrlFilter(key, value);
                this.setState({
                    selectedSearchType: key
                })
                // Giving some time to set all props
                setTimeout(() => {this.doSearch(key, value);}, 100); 
                break;
            }
        }
    }

    editCounterpartyClick = (counterparty) => {
        const data = this.state.searchResults;
        let counterpartyMasterData = [];
        if(data.counterparties && data.counterparties.length > 0){
            const foundCounterpartyData = data.counterparties.find(cpmd => cpmd.id === counterparty.id);
            if(foundCounterpartyData){
                this.props.loadInitialCounterpartyData(foundCounterpartyData)
            }
        }
        this.setState({
            counterpartyEditModal: true,
            selectedCounterparty : counterparty
        })
    }

    editCounterpartyMasterDataClick = (counterpartyId) => {
        const data = this.state.searchResults;
        if (this.state.counterpartyMasterData && this.state.counterpartyMasterData.length > 0) {
            const foundMasterData = data.counterpartiesMasterData.find(cpmd => cpmd.counterpartyId === counterpartyId);
            if(foundMasterData){
                if(foundMasterData.valueSet && foundMasterData.valueSet.length > 0){
                    let masterObj = {};
                    for(let vs of foundMasterData.valueSet){
                        masterObj[vs.key.name] = vs.value;
                    }
                    this.props.loadInitialCounterpartyMasterData(masterObj)
                }
            }
        }
        this.setState({
            counterpartyMasterDataEditModal: true
        })
    }

    handleCounterpartyClick = (counterparty) => {
        const data = this.state.searchResults;
        let counterpartyMasterData = [];
        let counterpartyMasterColumns = [];
        
        if(data.counterpartiesMasterData && data.counterpartiesMasterData.length > 0){
            const foundMasterData = data.counterpartiesMasterData.find(cpmd => cpmd.counterpartyId === counterparty.id);
            // console.log('found ==>',foundMasterData);
            if(foundMasterData){
                if(foundMasterData.valueSet && foundMasterData.valueSet.length > 0){
                    let masterObj = {};
                    for(let [i, vs] of foundMasterData.valueSet.entries()){
                        masterObj[vs.key.name] = vs.value;
                        counterpartyMasterColumns.push({
                            Header: vs.key.name,
                            accessor: vs.key.name,
                            id: vs.key.name,
                          });
                        
                        if (i === foundMasterData.valueSet.length - 1) {
                            counterpartyMasterColumns.push({
                                Header: "Edit",
                                accessor: k => <a href='javascript:void(0)' onClick={() => this.editCounterpartyMasterDataClick(counterparty.id)}><i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" /></a>,
                                id: "Edit"
                            });
                        }
                    }

                    // console.log('master obj==>',JSON.stringify(masterObj));
                    // console.log('master columns ==> ',JSON.stringify(counterpartyMasterColumns));
                    counterpartyMasterData.push(masterObj);
                }
            }
        }

        this.setState({
            counterpartyMasterData: counterpartyMasterData,
            counterpartyMasterColumns: counterpartyMasterColumns,
            selectedCounterparty : counterparty,
            showModal: true
        })
    }

    handleCounterpartyModelClosed = () => {
        this.setState({
            counterpartyMasterData: [],
            counterpartyMasterColumns: [],
            showModal: false
        })
    }

    handleCounterpartDataEditModelClosed = () => {
        this.props.loadInitialCounterpartyData(undefined)
        this.setState({
            counterpartyEditModal: false
        })
    }

    handleCounterpartMasterDataEditModelClosed = () => {
        this.props.loadInitialCounterpartyMasterData(undefined)
        this.setState({
            counterpartyMasterDataEditModal: false
        })
    }

    handleToggle = () => {
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen
        }))
    }

    submitCounterpartyData = (formValues) => {
        this.props.preloading(true);
        this.setState({ resizeZIndex: true })
        let masterDataObject = {
            MCA_CIN: formValues.cinNumber,
            Income_Tax_PAN_Number: formValues.panNo
        }
        let counterpartyObject = createRequestBody(formValues)
        let requestBody = {
            counterpartyId: this.state.selectedCounterparty.id,
            counterpartyData: { counterparty: counterpartyObject, counterpartyMasterData: masterDataObject }
        }
        this.props.updateCounterpartyData(requestBody)
    }

    submitCounterpartyMasterData = (formValues) => {
        this.props.preloading(true);
        this.setState(prevState => ({
            resizeZIndex: true,
            selectedCounterparty: {
                ...prevState.selectedCounterparty,
                cinNumber: formValues.MCA_CIN,
                panNo: formValues.Income_Tax_PAN_Number
            }
        }), () => {
            let requestBody = {
                counterpartyId: this.state.selectedCounterparty.id,
                counterpartyData: {
                    counterparty: this.state.selectedCounterparty,
                    counterpartyMasterData: formValues
                }
            };
            this.props.updateCounterpartyMasterData(requestBody);
    });
}

    render() {
        const data = this.state.searchResults;
        let columns = [];
        let editColumn = {};
        if(data && data.counterpartiesMasterData && data.counterparties && data.counterparties.length > 0){
            columns = Object.keys(data.counterparties[0]).map((key, index)=>{
                if(key === "country"){
                    return {
                        Header: key,
                        accessor: k => <span>{k.country.name}</span>,
                        id: key,
                      }
                }
                else if (key === "counterpartyName"){
                    return {
                        Header: key,
                        accessor: k => <a href='javascript:void(0)' onClick={() => this.handleCounterpartyClick(k)}>{k.counterpartyName}</a>,
                        id: key,
                      }
                }
                else if (key === "id"){
                    editColumn = {
                        Header: "Edit",
                        accessor: k => <a href='javascript:void(0)' onClick={() => this.editCounterpartyClick(k)}><i className="icon-edit border border-primary radius-4 p-2 font-size-16" color="primary" /></a>,
                        id: "Edit"+key,
                    }
                    return {
                        Header: key,
                        accessor: key,
                        id: key,
                      }
                }
                else if (key === "pfNumber") {
                    return {
                        Header: key,
                        accessor: k => (k.pfNumber ? (Array.isArray(k.pfNumber) ? k.pfNumber.join() : k.pfNumber) : ""),
                        id: key,
                    }
                }
                else{
                    return {
                        Header: key,
                        accessor: key,
                        id: key,
                    }
                }
              });
              columns.push(editColumn);
        }

        return (
            <Col>
                <Card>
                    <CardBody>
                        <Row className="search-case">
                            <Col sm='3'>
                                <DropdownSelect dropdownValues={this.SEARCH_TYPES} handleDropdown={this.dropdownCallback} selectedSearchType={this.state.selectedSearchType} dropdownOpen={this.state.isOpen} toggle={this.handleToggle} />
                            </Col>
                            <Col sm='12'>
                                <Form className="form-search">
                                    <FormGroup className="mb-0 input-search">
                                        <i className="icon-search position-absolute"></i>
                                        <Input className="bg-light" type="search" name="search" id="search" defaultValue={this.state.searchText} onKeyPress={this.handleSearchChange} placeholder="Search Counterparties" autoComplete="off" />
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                        <Row>
                            <Table
                                data={data.counterparties}
                                columns={columns}
                                defaultPageSize={50}
                                className="-striped -highlight"
                            />
                        </Row>
                    </CardBody>
                </Card>

                <Modal show={this.state.showModal} modalClosed={this.handleCounterpartyModelClosed} className={this.state.resizeZIndex ? "z-index-zero Modal master-data-modal-style" : "Modal master-data-modal-style"}>
                    <ModalHeader>{this.state.selectedCounterparty ? this.state.selectedCounterparty.counterpartyName : "-"}</ModalHeader>
                    <ModalBody>
                        <Table
                            data={this.state.counterpartyMasterData}
                            columns={this.state.counterpartyMasterColumns}
                            defaultPageSize={50}
                            className="-striped -highlight"
                        />
                    </ModalBody>
                </Modal>

                <Modal show={this.state.counterpartyEditModal} modalClosed={this.handleCounterpartDataEditModelClosed} className={this.state.resizeZIndex ? "z-index-zero Modal master-data-modal-style" : "Modal master-data-modal-style"}>
                    <EditCounterpartyForm handleCounterpartDataEditModelClosed={this.handleCounterpartDataEditModelClosed} submitCounterpartyData={this.submitCounterpartyData} />
                </Modal>
                <Modal show={this.state.counterpartyMasterDataEditModal} modalClosed={this.handleCounterpartMasterDataEditModelClosed} className={this.state.resizeZIndex ? "z-index-zero Modal master-data-modal-style" : "Modal master-data-modal-style"}>
                    <EditCounterpartyMasterDataForm handleCounterpartMasterDataEditModelClosed={this.handleCounterpartMasterDataEditModelClosed} submitCounterpartyMasterData={this.submitCounterpartyMasterData} />
                </Modal>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    searchResults: state.counterpartySearchData.counterpartySearchSuccess,
    searchError: state.counterpartySearchData.counterpartySearchFailure,
    counterpartyUpdateSuccess: state.counterpartySearchData.counterpartyUpdateSuccess,
    counterpartyUpdateFailure: state.counterpartySearchData.counterpartyUpdateFailure,
    counterpartyMasterUpdateSuccess: state.counterpartySearchData.counterpartyMasterUpdateSuccess,
    counterpartyMasterUpdateFailure: state.counterpartySearchData.counterpartyMasterUpdateFailure
});

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    search: (searchSelector, searchQuery) => { dispatch(CounterpartySearchActions.counterpartySearch({searchSelector, searchQuery})) },
    loadInitialCounterpartyData: (data) => dispatch(loadInitialCounterpartyData(data)),
    updateCounterpartyData: (data) => dispatch(CounterpartySearchActions.updateCounterpartyData(data)),
    loadInitialCounterpartyMasterData: (data) => dispatch(loadInitialCounterpartyMasterData(data)),
    updateCounterpartyMasterData: (data) => dispatch(CounterpartySearchActions.updateCounterpartyMasterData(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CounterpartySearch)